<template>
  <div class="container-fluid pt-0">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <h4 class="p-b-20">{{ $t("devs") }}</h4>
    <div
      id="setupaccount"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      v-bind:class="{ show: isOpen }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div
          v-if="isOpen"
          class="modal-content"
          v-click-outside="closeModal"
          id="modal"
        >
          <div class="card-body">
            <h5
              class="mx-0 px-2 pb-3"
              style="border-bottom: 1px solid rgba(0, 0, 0, 0.1)"
            >
              {{ $t("setup_dev") }}
            </h5>
            <div
              v-if="mssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ mssg }}
              </p>
            </div>
            <div
              v-else-if="Errormssg"
              align="center"
              class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ Errormssg }}
              </p>
            </div>
            <form class="p-2" @submit.prevent="setupaccount">
              <div class="form-group">
                <label>{{ $t("dev_email") }}</label>
                <input
                  type="email"
                  name="email"
                  v-model="email"
                  class="form-control"
                  required
                />
              </div>
              <div
                class="form-group"
                style="display:flex; justify-content: space-between"
              >
                <button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary"
                >
                  {{ $t("cancel") }}
                </button>
                <button type="submit" class="btn btn-primary">
                  Set up
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="card col-md-7 pl-0">
      <div class="card-body">
        <h5 class="mb-4">{{ $t("api_keys") }}</h5>
        <div v-if="developerkey" class="">
          <div class="mb-4">
            <div
              v-if="copymssg"
              align="center"
              class="alert alert-success alert-dismissible fade show text-center margin-bottom-1x"
            >
              <p class="alert-close mb-0">
                {{ copymssg }}
              </p>
            </div>
            <div class="mb-2">
              {{ $t("live_keys") }}
            </div>
            <div
              class="row col-md-12 p-2 ml-0"
              style="border-radius: 4px; border: 1px solid rgba(0, 0, 0, 0.1);"
            >
              <div id="livekey" class="col-10">
                {{ developerkey.liveKey }}
              </div>
              <div style="display: flex; align-items: center" class="col-2">
                <h6
                  @click.prevent="copyLiveKey"
                  style="cursor: pointer"
                  class="mb-0"
                >
                  {{ $t("copy") }}
                </h6>
              </div>
            </div>
          </div>
          <div class="form-group">
            <button
              @click.prevent="refreshKey"
              type="button"
              class="btn btn-primary"
            >
              {{ $t("gen_new_key") }}
            </button>
          </div>
        </div>

        <div v-else class="mt-2">
          <div class="mx-auto text-center col-md-6">
            <h5>{{ $t("no_dev") }}</h5>
            <p class="gray-4">
              {{ $t("start_dev_setup") }}
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <button
              data-step="1"
              data-intro="<h5 style='margin-bottom: 1rem; color: #213e7a'>Users</h5>Assign members of your team to monitor selected devices."
              @click="openModal"
              class="btn btn-primary"
            >
              {{ $t("create") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import store from "../../store/index";
import "intro.js/introjs.css";

export default {
  name: "Users",
  data() {
    return {
      isLoading: true,
      fullPage: true,
      isOpen: false,
      email: "",
      mssg: "",
      Errormssg: "",
      copymssg: "",
    };
  },
  mounted() {
    this.fetchDeveloperKeys().then(() => {
      this.isLoading = false;
    });
  },
  beforeRouteEnter(to, from, next) {
    // Checks if the user is a staff
    if (store.getters.profile.role === "staff") {
      next(from);
    } else {
      next();
    }
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Loading,
  },
  computed: {
    ...mapGetters(["developerkey"]),
  },
  methods: {
    ...mapActions([
      "fetchDeveloperKeys",
      "setupDeveloperAccount",
      "refreshDeveloperKeys",
    ]),
    onCancel() {
      this.isOpen = false;
      this.email = "";
      this.Errormssg = "";
      this.isLoading = false;
    },
    setupaccount() {
      this.isLoading = true;
      const developerMail = {
        email: this.email.toLowerCase(),
      };
      this.setupDeveloperAccount(developerMail)
        .then((res) => {
          this.isLoading = false;
          this.mssg =
            res.data.message[0].toUpperCase() + res.data.message.slice(1);
          //console.log(res.data.message);
          if (res.data.status === "success") {
            setTimeout(() => {
              this.isLoading = true;
              this.fetchDeveloperKeys();
            }, 1000);
            setTimeout(() => {
              this.onCancel();
              this.mssg = "";
            }, 4000);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    closeModal() {
      this.isOpen = false;
      this.onCancel();
    },
    openModal() {
      this.isOpen = true;
    },
    copyLiveKey() {
      const key = document.getElementById("livekey").innerHTML;
      var input = document.createElement("input");
      input.setAttribute("value", key);
      document.body.appendChild(input);
      input.select();
      var result = document.execCommand("copy");
      document.body.removeChild(input);
      this.copymssg = "API Key copied to clipboard!";
      setTimeout(() => {
        this.copymssg = "";
      }, 1000);

      return result;
    },
    refreshKey() {
      this.isLoading = true;
      this.refreshDeveloperKeys().then(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}
th.active {
  color: #fff;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
<i18n>
{
	"en": {
		"api_keys": "API Keys",
		"copy": "COPY",
		"create": "Create Account",
		"dev_email": "Developer Email",
		"devs": "Developers",
		"gen_new_key": "Generate new key",
		"live_keys": "Live Key",
		"no_dev": "You haven't set up a Developer Account yet",
		"setup": "Set up",
		"setup_dev": "Set up a Developer Account",
		"start_dev_setup": "Set up a developer account to start generating API Keys"
	},
	"es": {
		"api_keys": "Claves de api",
		"copy": "Dupdo",
		"create": "Crear una cuenta",
		"dev_email": "Correo electrónico del desarrollador",
		"devs": "Desarrolladores",
		"gen_new_key": "Generar nueva clave",
		"live_keys": "Clave en vivo",
		"no_dev": "Aún no ha configurado una cuenta de desarrollador",
		"setup": "Preparar",
		"setup_dev": "Configurar una cuenta de desarrollador",
		"start_dev_setup": "Configure una cuenta de desarrollador para comenzar a generar claves API"
	},
	"fr": {
		"api_keys": "Clés API",
		"copy": "COPIE",
		"create": "Créer un compte",
		"dev_email": "E-mail du développeur",
		"devs": "Développeurs",
		"gen_new_key": "Générer une nouvelle clé",
		"live_keys": "Clé en direct",
		"no_dev": "Vous n'avez pas encore configuré de compte développeur",
		"setup": "Mettre en place",
		"setup_dev": "Configurer un compte développeur",
		"start_dev_setup": "Configurer un compte développeur pour commencer à générer des clés API"
	},
	"sw": {
		"api_keys": "Vifunguo vya Api",
		"copy": "Nakala",
		"create": "Tengeneza akaunti",
		"dev_email": "Barua pepe ya Msanidi",
		"devs": "Watengenezaji",
		"gen_new_key": "Tengeneza ufunguo mpya",
		"live_keys": "Ufunguo wa Kuishi",
		"no_dev": "Bado hujafungua Akaunti ya Msanidi Programu",
		"setup": "Sanidi",
		"setup_dev": "Sanidi Akaunti ya Msanidi Programu",
		"start_dev_setup": "Sanidi akaunti ya msanidi ili kuanza kutengeneza Funguo za API"
	}
}
</i18n>
